// src/pages/admin/Services.jsx
import { useState } from 'react';
import { FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';
import AdminLayout from '../../components/dashboard/admin/AdminLayout';
import EditServices from '../../components/admin/services/EditServices';
import { useAdminServices } from '../../hooks/useAdminServices';

const AdminServices = () => {
  const {
    serviceList,
    serviceListMeta,
    updatingServices,
    error,
    addServiceToList,
    updateServiceInList,
    deleteServiceFromList,
    moveServiceUp,
    moveServiceDown,
    clearError,
  } = useAdminServices();

  const [success, setSuccess] = useState('');

  const showSuccess = (message) => {
    setSuccess(message);
    setTimeout(() => setSuccess(''), 5000);
  };

  return (
    <AdminLayout>
      <div className="max-w-4xl mx-auto py-6 px-4 sm:px-6 lg:px-8 space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Services</h1>
          <p className="text-sm text-gray-500 mt-1">
            Manage the service offerings shown on your site and used when creating invoices.
          </p>
        </div>

        {/* Error */}
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-start justify-between">
            <div className="flex items-start gap-3">
              <FaExclamationTriangle className="w-4 h-4 text-red-600 mt-0.5 flex-shrink-0" />
              <p className="text-sm text-red-700">{error}</p>
            </div>
            <button onClick={clearError} className="text-red-400 hover:text-red-600 text-sm ml-4">
              Dismiss
            </button>
          </div>
        )}

        {/* Success */}
        {success && (
          <div className="bg-green-50 border border-green-200 rounded-lg p-4 flex items-center gap-3">
            <FaCheckCircle className="w-4 h-4 text-green-600 flex-shrink-0" />
            <p className="text-sm text-green-700">{success}</p>
          </div>
        )}

        {/* Service List Editor */}
        <EditServices
          serviceList={serviceList}
          serviceListMeta={serviceListMeta}
          updatingServices={updatingServices}
          onAddService={addServiceToList}
          onUpdateService={updateServiceInList}
          onDeleteService={deleteServiceFromList}
          onMoveUp={moveServiceUp}
          onMoveDown={moveServiceDown}
          onSuccess={showSuccess}
        />
      </div>
    </AdminLayout>
  );
};

export default AdminServices;